import script from "./poc.vue?vue&type=script&lang=ts&setup=true"
export * from "./poc.vue?vue&type=script&lang=ts&setup=true"

import "./poc.vue?vue&type=style&index=0&id=8a0f2d38&scoped=true&lang=scss"

import exportComponent from "/opt/tiger/compile_path/src/code.byted.org/ad/se_tt4b_academy_advertiser_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a0f2d38"]])

export default __exports__